import Beneficiary from '../../model/beneficiary';

export const state = {
    beneficiaries: [],
}

export const mutations = {
    setBeneficiaries(state, beneficiaries) {
        state.beneficiaries = beneficiaries.map((beneficiary, index)=> new Beneficiary(beneficiary, index))
    } 
}

export const getters = {
    getBeneficiaries(state) {
        return state.beneficiaries;
    },
}

export const actions = {
    // addList({commit, state}, beneficiary){
    //     return commit('setBeneficiaries', [...state.beneficiaries, beneficiary]);
    // },
    // delete({commit, state}, id){
    //     return commit('setBeneficiaries', state.beneficiaries.filter((x)=>x.id != id));
    // },
}